export interface Font {
  code: string;
  displayName: string;
  isRestricted: boolean;
}

export const FONTS: Font[] = [
  { code: 'DMSans-Regular', displayName: 'DM Sans', isRestricted: false },
  { code: 'Lato-Regular', displayName: 'Lato', isRestricted: false },
  { code: 'Montserrat-Black', displayName: 'Montserrat Black', isRestricted: false },
  { code: 'Montserrat-Medium', displayName: 'Montserrat Medium', isRestricted: false },
  { code: 'Montserrat-Regular', displayName: 'Montserrat Regular', isRestricted: false },
  { code: 'Mulish-Regular', displayName: 'Mulish Regular', isRestricted: false },
  { code: 'Mulish-Variable', displayName: 'Mulish Variable', isRestricted: false },
  { code: 'NotoSans-Regular', displayName: 'Noto Sans', isRestricted: false },
  { code: 'Poppins', displayName: 'Poppins', isRestricted: false },
  { code: 'Roboto', displayName: 'Roboto', isRestricted: false },
  { code: 'RobotoCondensed', displayName: 'Roboto Condensed', isRestricted: false },
  // Proprietary / Restricted fonts (marked proprietary or client-specific in CSS)
  { code: 'AGaramondPro', displayName: 'A Garamond Pro', isRestricted: true },
  { code: 'Anivers-Bold', displayName: 'Anivers Bold', isRestricted: true },
  { code: 'Anivers-Regular', displayName: 'Anivers Regular', isRestricted: true },
  { code: 'Avenir-Heavy', displayName: 'Avenir Heavy', isRestricted: true },
  { code: 'BKMU240327-1635-Regular', displayName: 'BKMU240327 Regular', isRestricted: true },
  { code: 'BrandonGrotesque', displayName: 'Brandon Grotesque', isRestricted: true },
  { code: 'CaseText-Bold', displayName: 'Case Text Bold', isRestricted: true },
  { code: 'CaseText-Medium', displayName: 'Case Text Medium', isRestricted: true },
  { code: 'CaseText-Regular', displayName: 'Case Text Regular', isRestricted: true },
  { code: 'ChampionHeviweight', displayName: 'Champion Heviweight', isRestricted: true },
  { code: 'CircularProBold', displayName: 'Circular Pro Bold', isRestricted: true },
  { code: 'CircularProBook', displayName: 'Circular Pro Book', isRestricted: true },
  { code: 'Cocogoose', displayName: 'Cocogoose', isRestricted: true },
  { code: 'Gotham-Black', displayName: 'Gotham Black', isRestricted: true },
  { code: 'Gotham-Bold', displayName: 'Gotham Bold', isRestricted: true },
  { code: 'Gotham-Book', displayName: 'Gotham Book', isRestricted: true },
  { code: 'Halyard-Book', displayName: 'Halyard Book', isRestricted: true },
  { code: 'Halyard-Regular', displayName: 'Halyard Regular', isRestricted: true },
  { code: 'HelveticaNeueLight', displayName: 'Helvetica Neue Light', isRestricted: true },
  { code: 'Moderat-Bold', displayName: 'Moderat Bold', isRestricted: true },
  { code: 'ProximaNova-Regular', displayName: 'Proxima Nova Regular', isRestricted: true },
  { code: 'ProximaNovaCondensed-Regular', displayName: 'Proxima Nova Condensed', isRestricted: true },
  { code: 'ReplicaStd', displayName: 'Replica Std Regular', isRestricted: true },
  { code: 'ReplicaStd-Bold', displayName: 'Replica Std Bold', isRestricted: true },
  { code: 'ReplicaStd-Light', displayName: 'Replica Std Light', isRestricted: true },
  { code: 'RomanWoodTypeJNL', displayName: 'Roman Wood Type JNL', isRestricted: true },
  { code: 'Rubik', displayName: 'Rubik', isRestricted: true },
  { code: 'SentinelPro-Semibold', displayName: 'Sentinel Pro Semibold', isRestricted: true },
  { code: 'Tarzana-Bold', displayName: 'Tarzana Bold', isRestricted: true },
  { code: 'Tarzana-Regular', displayName: 'Tarzana Regular', isRestricted: true },
  { code: 'Verlag-Black', displayName: 'Verlag Black', isRestricted: true },
  { code: 'Verlag-Bold', displayName: 'Verlag Bold', isRestricted: true },
  { code: 'Verlag-Book', displayName: 'Verlag Book', isRestricted: true },
  { code: 'Whitney-Book-Pro', displayName: 'Whitney Book Pro', isRestricted: true },
  { code: 'WhitneyHTF-Book', displayName: 'Whitney HTF Book', isRestricted: true }
];
